import React, {useEffect, useState} from 'react'
import {toast} from 'react-toastify'
import {integrationArgus} from '../../../../components/requests'

interface props {
  dataPrix?: any
  showNextModal?: any
  modalDismissRef?: any
  setDataModifPrix?: any
  isNothingToNext?: boolean
  countRef?: number
  idsArgus?: string | null
  setTotalPrixManuel?: any
  totalPrixManuel?: number | undefined
  totalNontraitee?: number | undefined
  setTotalNontraitee?: any
  dataRefOe?: any | null | undefined
}

const PrixTarification = ({
  dataPrix,
  showNextModal,
  modalDismissRef,
  setDataModifPrix,
  isNothingToNext,
  countRef,
  idsArgus,
  setTotalPrixManuel,
  totalPrixManuel,
  totalNontraitee,
  setTotalNontraitee,
  dataRefOe = null,
}: props) => {
  let dataMetrique: any = {}
  if (dataPrix?.metriques) {
    dataMetrique = JSON.parse(dataPrix?.metriques)
  }

  const [prixMin, setPrixMin] = useState<any>(
    dataMetrique?.prixMiniCouloir !== null ? dataMetrique?.prixMiniCouloir.toFixed(2) : 0
  )
  const [prixMax, setPrixMax] = useState<any>(
    dataMetrique?.prixMaxiCouloir !== null ? dataMetrique?.prixMaxiCouloir.toFixed(2) : 0
  )
  const [nouveauPrix, setNouveauPrix] = useState<any>(
    dataPrix?.nouveauPrix !== null ? dataPrix?.nouveauPrix.toFixed(2) : 0
  )
  const [isModifPrix, setIsModifPrix] = useState<boolean>(false)

  useEffect(() => {
    setNouveauPrix(dataPrix?.nouveauPrix !== null ? dataPrix?.nouveauPrix.toFixed(2) : 0)
  }, [dataPrix])

  const handleTotalPrix = () => {
    //((Valeur Max - valeur Min) X Indice )+ valeur Min
    let total =
      Number(prixMin) + (Number(prixMax) - Number(prixMin)) * Number(dataMetrique?.indiceGlobal)
    const totalConvert = total.toFixed(2)

    setNouveauPrix(totalConvert)
  }

  const handleValidation = () => {
    const idToastValidate = toast.loading("Validation d'integration argus en cours...")

    integrationArgus(dataRefOe, nouveauPrix, dataPrix?.id).then((res) => {
      if (res?.data && res.status === 200) {

        const countTotalResult = res?.data?.modificationsPrix?.length
        const countTotalNonTraitee = res?.data?.totalNontraitee ?? 0

        if (totalPrixManuel && countTotalResult) {
          setTotalPrixManuel(totalPrixManuel - countTotalResult) // mise à jour du compte des nombres de statuts 'prix manuel'
        }

        if (totalNontraitee && countTotalNonTraitee) {
          setTotalNontraitee(totalNontraitee + countTotalNonTraitee) // mise à jour du compte des nombres de statuts 'non traitee'
        }

        const prixModifies = res?.data?.modificationsPrix || []
        if (prixModifies.length > 0) {
          setDataModifPrix((prev) =>
            prev.map((item) => {
              const modif = prixModifies.find((resItem) => resItem.id === item?.id)

              return modif
                ? {
                    ...item,
                    nouveauPrix: modif.nouveauPrix,
                    prixManuel: 0,
                  }
                : item
            })
          )
        }

        toast.update(idToastValidate, {
          render: 'Integration argus effectuée avec succès',
          type: 'success',
          isLoading: false,
          autoClose: 3000,
        })

        if (modalDismissRef.current) {
          modalDismissRef.current.click()
          setTimeout(() => {
            showNextModal()
          }, 1000)
        }
      } else {
        toast.update(idToastValidate, {
          render: "Une erreur s'est produite",
          type: 'error',
          isLoading: false,
          autoClose: 3000,
        })
      }
    })
  }

  return (
    <>
      {/* debut d'affichage de l'échelle du bloc au millieu */}
      <div className='d-flex justify-content-center align-items-end mt-5'>
        {/* Bloc MIN */}
        <div className='d-flex flex-column align-items-center'>
          <span className='mb-1 text-muted'>Min (€ TTC)</span>
          {/*<div className='border btn btn-light-info border-1 border-secondary h-50px text-center rounded-1 d-flex justify-content-center align-items-center'>*/}
          <div
            className='border bg-light-info border-1 border-secondary h-50px text-center rounded-1 d-flex justify-content-center align-items-center'
            style={{width: '128px'}}
          >
            <input
              type='number'
              value={prixMin}
              onChange={(e) => {
                setPrixMin(e.target.value)
                setIsModifPrix(true)
              }}
              className='w-50 border-0 text-center'
              style={{background: 'none'}}
            />{' '}
          </div>
          {/*</div>*/}
        </div>
        {/* Barre + point */}
        <div
          className='position-relative w-25 mx-3 d-flex align-items-center'
          style={{height: '50px'}}
        >
          {/* hr centré parfaitement */}
          <hr className='w-100 h-2px border-0 bg-info m-0' />
          <div
            className='position-absolute'
            style={{
              left: '48%',
              top: '50%',
              transform: 'translate(-50%, -50%)',
            }}
          >
            <div className='bg-dark rounded-circle' style={{width: '10px', height: '10px'}}></div>
            <div
              className='position-absolute text-white px-2 py-1 rounded'
              style={{
                top: '-35px',
                left: '50%',
                transform: 'translateX(-50%)',
                fontSize: '12px',
                whiteSpace: 'nowrap',
                backgroundColor: 'green',
              }}
            >
              ig:{' '}
              {dataMetrique?.indiceGlobal != null
                ? `${dataMetrique?.indiceGlobal.toFixed(2)}`
                : '0'}
            </div>
          </div>
        </div>
        {/* Bloc MAX */}
        <div className='d-flex gap-2 align-items-end'>
          <div className='d-flex flex-column align-items-center'>
            <span className='mb-1 text-muted'>Max (€ TTC)</span>
            <div
              className='h-50px border bg-light-danger border-1 border-secondary text-center rounded-1 d-flex justify-content-center align-items-center'
              style={{width: '128px'}}
            >
              <input
                type='number'
                value={prixMax}
                onChange={(e) => {
                  setPrixMax(e.target.value)
                  setIsModifPrix(true)
                }}
                className='w-50 border-0 text-center'
                style={{background: 'none'}}
              />{' '}
            </div>
          </div>
          <button
            className={`btn btn-secondary text-center h-50px ${!isModifPrix ? 'disabled' : ''}`}
            onClick={() => handleTotalPrix()}
          >
            Aide au calcul
          </button>
        </div>
      </div>
      {/* fin d'affichage de l'échelle du bloc au millieu */}

      <div className='d-flex justify-content-between align-items-end mt-5'>
        <span className='w-25'></span>
        <div className='d-flex flex-column align-items-left w-25'>
          <span className='mb-1 text-muted'>Nouveau prix (€ TTC)</span>
          <div
            className='h-50px text-center bg-primary border-1 border-secondary rounded-1 rounded-1 d-flex justify-content-center align-items-center'
            style={{width: '128px'}}
          >
            <input
              type='text'
              inputMode='decimal'
              value={nouveauPrix}
              className='w-50 border-0 text-center'
              style={{background: 'none'}}
              onFocus={(e) => e.target.select()}
              onChange={(e) => {
                const val = e.target.value.replace(',', '.')
                if (val === '' || /^[0-9]*\.?[0-9]{0,2}$/.test(val)) {
                  setNouveauPrix(val)
                }
              }}
              onBlur={(e) => {
                const numericValue = parseFloat(e.target.value)
                if (isNaN(numericValue)) {
                  setNouveauPrix('')
                  return
                }
                const formattedValue = numericValue.toFixed(2)
                if (formattedValue === '0.00' || numericValue === 0) {
                  setNouveauPrix('')
                } else {
                  setNouveauPrix(formattedValue)
                }
              }}
            />
          </div>
        </div>

        <div className='d-flex flex-column align-items-center'>
          {countRef && countRef > 1 ? (
            <span className='text-gray-600 fs-5'>
              {countRef} pièces seront concernées par votre action
            </span>
          ) : (
            <span className='text-gray-600 fs-5'></span>
          )}
          <button
            className={`h-50px btn text-white ${
              dataRefOe.length > 0 ? 'bg-primary' : 'disabled bg-primary'
            }`}
            onClick={handleValidation}
            disabled={!nouveauPrix || nouveauPrix == 0}
          >
            Intégrer Argus {!isNothingToNext && 'et passer au suivant'}
          </button>
        </div>
      </div>
    </>
  )
}

export {PrixTarification}
